import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-6", "4 Pong Arena", "img/projects/4pong_logo.png", `
    <div class="paragraph">
      <strong>4 Pong Arena</strong> is a 4 player arcade videogame made with Gaia engine by an 8 member team. <strong>4 Pong Arena</strong> is a 4 player pong where you have to be the last one standing to win.
      <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>.
    </div>
    
    <div class="paragraph center">
      <iframe class="youtube" src=" https://www.youtube.com/embed/qUHf8a1pQzo" frameborder="0" allowfullscreen></iframe>
    </div>
         
          <div class="paragraph">
            Main features :
            <ul>
            <li>Up to 4 player local multiplayer</li>
            <li>Gameplay based in the original pong</li>
            <li>3 different maps with up to 6 variants</li>
            <li>Enemy AIs to play against</li>
            </ul>
        </div>

        <div class="paragraph">
        <div class="notice">
            Windows build available on <a href="https://spicy-noodles-studio.github.io/4-Pong-Arena/" target="_blank">4 Pong Arena's page</a>.
            Source code is available on <a href="https://github.com/Spicy-Noodles-Studio/4-Pong-Arena" target="_blank">GitHub</a>.
        </div>
        </div>

        <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/4pong_2.png" alt="4 Pong Screenshot" />
          <img class="pc-screenshot" src="img/projects/4pong_1.png" alt="4 Pong Screenshot" />
        </div>
    `, "#000000", false, true),
    new ProjectData("project-7", "Volleybot Revenge", "img/projects/volleybot_title.png", `
    <div class="paragraph">
                <strong>Volleybot Revenge</strong> is a 3D beat 'em up made by 3 people in 3 days for the Mix and Jam 2020. In <strong>Volleybot Revenge</strong> your objective is to beat the invading robots by using your volleyball skils.
                <br/>Art by <a target="_blank" href="https://www.arturogcdev.games/#slide01">Arturo García</a>.
            </div>

            <div class="paragraph center">
                <iframe class="youtube" src="https://www.youtube.com/embed/-_oXLQq752E" frameborder="0" allowfullscreen></iframe>
            </div>

            <div class="paragraph">
              Main features :
              <ul>
              <li>Fast paced isometric view beat'em up</li>
              <li>Three different levels with multple stages</li>
              <li>Kill enemies with volleyball moves</li>
              <li>2 different enemies and a final boss</li>
              </ul>
          </div>
          
          <div class="paragraph">
          <div class="notice">
              WebGL build available on <a href="https://arturogcdev.itch.io/volleybot-revenge" target="_blank">itch.io</a>.
          </div>
          </div>

            <div class="paragraph center">
            <img class="pc-screenshot" src="img/projects/volleybot_menu.png" alt="Volleybot Screenshot" /> 
            <img class="pc-screenshot" src="img/projects/volleybot_boss.png" alt="Volleybot Screenshot" /> 
            </div>`),
    new ProjectData("project-8", "Not New Super Mario", "img/projects/not_new_super_mario_logo.png", `
    <div class="paragraph">
                <strong>Not New Super Mario</strong> is a Super Mario Odyssey 2D demake made by 2 people using javascript. In <strong>Not New Super Mario</strong> you caan play the first world of Super Mario Odyssey in 2d, with all the mechanics from the original game.
            </div>

          <div class="paragraph">
          Main features :
          <ul>
          <li>2D recreation of Super Mario's cascade kingdom with a final boss</li>
          <li>All the originals mechanics in 2D</li>
          <li>Turn yourself into goombas or chomp chomps</li>
          <li>Collect all the moons and special coins</li>
          </ul>
      </div>

            <div class="paragraph">
              <div class="notice">
                Game available to play <a href="https://apoyatos.github.io/Not-New-Super-Mario/docs/#" target="_blank">here</a> Source code available on <a href="https://github.com/apoyatos/Not-New-Super-Mario" target="_blank">GitHub</a>.
              </div>
            </div>

            <div class="paragraph center">
            <img class="pc-screenshot" src="img/projects/not_new_super_mario_1.PNG" alt="Not new super Mario Screenshot" /> 
            <img class="pc-screenshot" src="img/projects/not_new_super_mario_2.PNG" alt="Not new super Mario Screenshot" /> 
            <img class="pc-screenshot" src="img/projects/cascade_kingdom.png" alt="Not new super Mario Screenshot" /> 
            </div>`),  
];